// Ширина экрана, выше которой хедер показывает десктопный вариант
// (полный логотип, ссылка "About us" и кнопка "Menu").
export const HEADER_DESKTOP_MIN_WIDTH = 1024;
